import connectLookingSimilar from "instantsearch.js/es/connectors/looking-similar/connectLookingSimilar.js";
import { useConnector } from "../hooks/useConnector.js";
export function useLookingSimilar(props, additionalWidgetProperties) {
  return useConnector(connectLookingSimilar, props, additionalWidgetProperties);
}